import React, { type ReactElement, type ReactNode } from 'react';
import clsx from 'clsx';
import styles from './buttons-container.module.scss';

type Props = {
  allowSpaceForClearButton: boolean;
  allowSpaceForSelectedItemCount: boolean;
  children: ReactNode[];
};

export default function ButtonsContainer({
  allowSpaceForClearButton,
  allowSpaceForSelectedItemCount,
  children
}: Props): ReactElement {
  return (
    <div
      className={clsx(styles.buttonsContainer, {
        [`${styles.buttonsContainerWithSelectedItemCount}`]: allowSpaceForSelectedItemCount,
        [`${styles.buttonsContainerWithClearSelection}`]:
          allowSpaceForClearButton && !allowSpaceForSelectedItemCount
      })}
    >
      {children}
    </div>
  );
}
